/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMinimize = createReactComponent("outline", "minimize", "IconMinimize", [["path", { "d": "M15 19v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M15 5v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M5 15h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M5 9h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }]]);

export { IconMinimize as default };
//# sourceMappingURL=IconMinimize.mjs.map
